import { call, put, takeLatest } from 'redux-saga/effects';
import { error, request, success } from 'store/api/actions';
import { baseApi } from 'store/api/apiRequestBuilder';
import { logger } from 'utils';

import { follow } from '../actions';
import profileActionTypes from '../actionTypes';

import { getProfileInfoSaga } from './getProfileInfo';

export function* followSaga({ type, payload: { id } }: ReturnType<typeof follow>) {
  yield put(request(type));

  try {
    yield call(baseApi.follow, { id });

    yield call(getProfileInfoSaga, {
      type: profileActionTypes.GET_PROFILE,
      payload: { id },
    });

    yield put(success(type));
  } catch (e) {
    logger('Follow user', e);
    put(error(type));
  }
}

export default function* listener() {
  yield takeLatest(profileActionTypes.FOLLOW, followSaga);
}
